__turbopack_context__.v({
  "active": "mobile-section-nav-module__kcQhEW__active",
  "bar": "mobile-section-nav-module__kcQhEW__bar",
  "hidden": "mobile-section-nav-module__kcQhEW__hidden",
  "item": "mobile-section-nav-module__kcQhEW__item",
  "itemIcon": "mobile-section-nav-module__kcQhEW__itemIcon",
  "itemLabel": "mobile-section-nav-module__kcQhEW__itemLabel",
});
